import { createTheme } from "@mui/material";

export const appTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "& #root": {
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        },
      },
    },
  },
  fontFamily: "Roboto, sans-serif",
  palette: {
    background: {
      default: "#fafafa",
    },
    primary: {
      main: "#1953B7",
      light: "#90caf9",
      dark: "#002c86",
    },
    error: {
      main: "#BA1A1A",
    },
    tertiary: {
      main: "#90caf9",
      light: "#90caf9",
      dark: "#90caf9",
    },
    grey: {
      main: "#808080",
      dark: "#5A5A5A",
      light: "#C0C0C0",
      veryLight: "#F0F0F0",
    },
  },
});
